import React, { useState } from "react";

const initialData = [
  { id: "1", category: "Electronics", attribute: "Brand", value1: "", value2: "" },
  { id: "2", category: "Electronics", attribute: "Warranty", value1: "", value2: "" },
  { id: "3", category: "Clothing", attribute: "Material", value1: "", value2: "" },
];

export default function ExcelEditor() {
  const [data, setData] = useState(initialData);
  const [backup, setBackup] = useState(initialData); // For Undo

  const handleEdit = (id: string, key: "value1" | "value2", value: string) => {
    setData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [key]: value } : row))
    );
  };

  const handleSave = () => {
    setBackup([...data]); // Save backup before confirming changes
    alert("Data saved!");
  };

  const handleUndo = () => {
    setData([...backup]); // Restore from backup
  };

  return (
    <div className="p-4">
      <div className="flex gap-4 mb-4">
        <button onClick={handleSave} className="px-4 py-2 bg-green-500 text-white rounded">Save</button>
        <button onClick={handleUndo} className="px-4 py-2 bg-gray-500 text-white rounded">Undo</button>
      </div>

      <table className="w-full border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 border">Category</th>
            <th className="p-2 border">Attribute</th>
            <th className="p-2 border">Value 1</th>
            <th className="p-2 border">Value 2</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.id}>
              <td className="p-2 border">{row.category}</td>
              <td className="p-2 border">{row.attribute}</td>
              <td className="p-2 border">
                <input
                  type="text"
                  className="w-full p-1 border rounded"
                  value={row.value1}
                  onChange={(e) => handleEdit(row.id, "value1", e.target.value)}
                />
              </td>
              <td className="p-2 border">
                <input
                  type="text"
                  className="w-full p-1 border rounded"
                  value={row.value2}
                  onChange={(e) => handleEdit(row.id, "value2", e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
